<div class="h-full w-full tag-container" *ngIf="params.value">
  <div class="tag-box">
    <fa-icon *ngIf="logo" [icon]="['fal', logo]" class="fs-07 mr-2"></fa-icon>{{ params.value }}
  </div>
</div>
